import React from 'react';

import { HeroBanner } from '@/views/B2BLanding/sections';

import { BannerSectionProps } from './types';

const BannerSection: React.FC<React.PropsWithChildren<BannerSectionProps>> = ({
  title,
  description,
}) => (
  <HeroBanner title={title} description={description} onTryFree={() => {}} />
);

export default BannerSection;
